export const initialState = {
  base: {
    allIDs: [],
    byId: {},
  },
  byBoard: {
    // :boardId [teamMemberId]
  },
  byOrganization: {
    // :organizationId [teamMemberId]
  },
  ui: {
    isDeactivatingUser: false,
    isFetchingTeam: false,
    isFetchingTeamMember: false,
    isInvitingTeamMember: false,
    isUpdatingTeamMember: false,
  },
};

export const teamMemberSchema = {
  additionalProperties: false,
  properties: {
    assignedBoardIDs: { type: ['null', 'array'] },
    createdAt: { type: 'number' },
    disabled: { default: false, type: 'boolean' },
    email: { type: 'string' },
    firstName: { type: 'string' },
    icon: { type: 'string' },
    lastActiveAt: { type: 'number' },
    lastName: { type: 'string' },
    pending: { type: 'boolean' },
    phoneNumber: { type: 'string' },
    role: { type: 'string' },
    userId: { type: 'string' },
  },
  type: 'object',
};
